/* src/app/builder-screen-beta/performance/virtual-scroll-property-list.component.scss */
.virtual-property-viewport {
  width: 100%;
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  background: white;
}
.virtual-property-viewport :host ::ng-deep .cdk-virtual-scroll-content-wrapper::-webkit-scrollbar {
  width: 6px;
}
.virtual-property-viewport :host ::ng-deep .cdk-virtual-scroll-content-wrapper::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-radius: 3px;
}
.virtual-property-viewport :host ::ng-deep .cdk-virtual-scroll-content-wrapper::-webkit-scrollbar-thumb {
  background: #d9d9d9;
  border-radius: 3px;
}
.virtual-property-viewport :host ::ng-deep .cdk-virtual-scroll-content-wrapper::-webkit-scrollbar-thumb:hover {
  background: #bfbfbf;
}
.virtual-property-item {
  border-bottom: 1px solid #f5f5f5;
}
.virtual-property-item:last-child {
  border-bottom: none;
}
.virtual-property-item[data-item-type=group-header] {
  background: #fafafa;
  border-bottom: 2px solid #e8e8e8;
}
.virtual-property-item[data-item-type=separator] {
  background: transparent;
  border-bottom: none;
}
.group-header-virtual {
  padding: 0;
}
.group-header-virtual :host ::ng-deep .ant-collapse {
  border: none;
  background: transparent;
}
.group-header-virtual :host ::ng-deep .ant-collapse .ant-collapse-item {
  border: none;
}
.group-header-virtual :host ::ng-deep .ant-collapse .ant-collapse-item .ant-collapse-header {
  padding: 12px 16px;
  background: transparent;
  border-radius: 0;
}
.group-header-virtual :host ::ng-deep .ant-collapse .ant-collapse-item .ant-collapse-header:hover {
  background: #f0f0f0;
}
.group-header-virtual :host ::ng-deep .ant-collapse .ant-collapse-item .ant-collapse-content {
  display: none;
}
.group-header-content {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}
.group-header-content .anticon {
  color: #1890ff;
  font-size: 14px;
}
.group-header-content .group-title {
  flex: 1;
  font-weight: 500;
  color: #262626;
}
.group-header-content .ant-badge :host ::ng-deep .ant-badge-count {
  background: #1890ff;
  font-size: 10px;
  min-width: 16px;
  height: 16px;
  line-height: 16px;
  padding: 0 4px;
}
.property-item-virtual {
  padding: 8px 16px;
}
.property-item-virtual:hover {
  background: #f9f9f9;
}
.property-item-virtual.compact {
  padding: 4px 12px;
}
.property-item-virtual.compact :host ::ng-deep .property-control .ant-form-item {
  margin-bottom: 0;
}
.property-item-virtual.compact :host ::ng-deep .property-control .ant-form-item-label {
  padding-bottom: 2px;
}
.property-item-virtual.compact :host ::ng-deep .property-control .ant-form-item-label label {
  font-size: 11px;
}
.property-item-virtual.compact :host ::ng-deep .property-control .ant-form-item-control .ant-input,
.property-item-virtual.compact :host ::ng-deep .property-control .ant-form-item-control .ant-input-number,
.property-item-virtual.compact :host ::ng-deep .property-control .ant-form-item-control .ant-select-selector {
  height: 28px;
  font-size: 12px;
}
.separator-virtual {
  padding: 0 16px;
}
.separator-virtual :host ::ng-deep .ant-divider {
  margin: 8px 0;
  border-color: #f0f0f0;
}
.virtual-property-item {
  will-change: transform;
  contain: layout style paint;
}
.virtual-property-viewport.loading {
  position: relative;
}
.virtual-property-viewport.loading::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  z-index: 10;
}
.virtual-property-viewport.loading::after {
  content: "Loading properties...";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #8c8c8c;
  font-size: 14px;
  z-index: 11;
}
.virtual-property-viewport.empty {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8c8c8c;
  font-size: 14px;
}
.virtual-property-viewport.empty::before {
  content: "No properties to display";
}
@media (max-width: 768px) {
  .group-header-content {
    gap: 6px;
  }
  .group-header-content .group-title {
    font-size: 13px;
  }
  .group-header-content .anticon {
    font-size: 12px;
  }
  .property-item-virtual {
    padding: 6px 12px;
  }
}
@media (prefers-contrast: high) {
  .virtual-property-viewport {
    border: 2px solid #000;
  }
  .virtual-property-item {
    border-bottom: 1px solid #000;
  }
  .virtual-property-item[data-item-type=group-header] {
    background: #f0f0f0;
    border-bottom: 2px solid #000;
  }
  .group-header-content .anticon {
    color: #000;
  }
  .group-header-content .group-title {
    color: #000;
  }
}
@media (prefers-reduced-motion: reduce) {
  .virtual-property-item {
    will-change: auto;
  }
  .property-item-virtual {
    transition: none;
  }
  .group-header-virtual :host ::ng-deep .ant-collapse-header {
    transition: none;
  }
}
/*# sourceMappingURL=virtual-scroll-property-list.component.css.map */
